import { useEffect, useState } from "react";
import { getNativeNetworkStatus } from "../platform/lifecycle";

export function isOnline(): boolean {
  return getNativeNetworkStatus() ?? (typeof navigator === "undefined" ? true : navigator.onLine);
}

export function useNetworkStatus(): boolean {
  const [online, setOnline] = useState(isOnline());
  useEffect(() => {
    const update = () => setOnline(isOnline());
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);
  return online;
}
